import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './assets/main.module.scss';
import { StoreState } from '../../store/reducers';

export interface StateProps {}
interface Props {
    children?: ReactNode;
}
const RoleLayout: React.FC<Props> = (props: Props) => {
    return (
        <React.Fragment>
            <div className={classNames(styles.mainContent)}>{props.children}</div>
        </React.Fragment>
    );
};
export default connect((state: StoreState): StateProps => ({ data: state.districts.data }), {})(RoleLayout);
